
<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
    <div class="max-w-md w-full">
      

      <!-- Card -->
      <div class="bg-white rounded-xl shadow-lg p-8">
        <!-- Logo -->
      <div class="flex justify-center mb-8">
        <img src="/logo.webp" alt="Optyfind" class="h-20 w-auto" />
      </div>
        <h2 class="text-2xl font-bold text-gray-900 text-center mb-6">
          Sign in to your account
        </h2>

        <form @submit.prevent="handleLogin" class="space-y-4">
          <!-- Email -->
          <div>
            <label for="email-address" class="block text-sm font-medium text-gray-700 mb-1">Email address</label>
            <div class="relative">
              <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg class="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <input
                id="email-address"
                v-model="email"
                type="email"
                autocomplete="email"
                required
                class="block w-full pl-10 pr-3 py-2.5 border border-gray-300 rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500 sm:text-sm"
                placeholder="you@example.com"
              />
            </div>
          </div>

          <!-- Password -->
          <div>
            <label for="password" class="block text-sm font-medium text-gray-700 mb-1">Password</label>
            <div class="relative">
              <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg class="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
              </div>
              <input
                id="password"
                v-model="password"
                type="password"
                autocomplete="current-password"
                required
                class="block w-full pl-10 pr-3 py-2.5 border border-gray-300 rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500 sm:text-sm"
                placeholder="Enter your password"
              />
            </div>
          </div>

          <!-- Error -->
          <div v-if="error" class="rounded-lg bg-red-50 p-3 text-red-600 text-sm text-center">
            {{ error }}
          </div>

          <!-- Submit -->
          <button
            type="submit"
            :disabled="loading"
            class="w-full flex justify-center py-2.5 px-4 border border-transparent text-sm font-semibold rounded-lg text-white bg-brand-600 hover:bg-brand-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-500 disabled:opacity-50 transition-colors"
          >
            {{ loading ? 'Signing in...' : 'Sign in' }}
          </button>
        </form>

        <!-- Register link -->
        <div class="mt-6 text-center border-t border-gray-100 pt-4">
          <router-link
            to="/register"
            class="text-sm font-medium text-brand-600 hover:text-brand-500"
          >
            Don't have an account? Register
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '../stores/auth';

export default {
  name: 'UserLogin',
  setup() {
    const router = useRouter();
    const authStore = useAuthStore();
    const email = ref<string>('');
    const password = ref<string>('');
    const error = ref<string>('');
    const loading = ref<boolean>(false);

    const handleLogin = async (): Promise<void> => {
      error.value = '';
      loading.value = true;

      try {
        await authStore.login(email.value, password.value);
        if (!authStore.user?.country_code) {
          router.push('/profile-setup');
        } else {
          const raw = router.currentRoute.value.query.redirect;
          const redirectPath = (raw && typeof raw === 'string' && raw.startsWith('/') && !raw.startsWith('//')) ? raw : '/';
          router.push(redirectPath);
        }
      } catch (err: any) {
        error.value = err.response?.data?.message || 'Login failed. Please try again.';
      } finally {
        loading.value = false;
      }
    };

    return {
      email,
      password,
      error,
      loading,
      handleLogin,
    };
  },
};
</script>
